import { IBreadCrumb } from './model/ibread-crumb';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './bread-crump.component.html'
})
export class BreadcrumbComponent implements OnInit {

  @Input() breadcrumbItems: IBreadCrumb[] ;

  constructor() { }

  ngOnInit() { }

}
